module.exports = __webpack_public_path__ + "img/adhesive_residue.dfec7d91.jpeg";